/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Paste_TitleInputs */

const en_context_menu_paste_title = /** @type {(inputs: Context_Menu_Paste_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste Events`)
};

const fr_context_menu_paste_title = /** @type {(inputs: Context_Menu_Paste_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coller des evenements`)
};

const de_context_menu_paste_title = /** @type {(inputs: Context_Menu_Paste_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignisse einfügen`)
};

const it_context_menu_paste_title = /** @type {(inputs: Context_Menu_Paste_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla eventi`)
};

const ru_context_menu_paste_title = /** @type {(inputs: Context_Menu_Paste_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставить события`)
};

const es_context_menu_paste_title = /** @type {(inputs: Context_Menu_Paste_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pegar eventos`)
};

const zh_cn2_context_menu_paste_title = /** @type {(inputs: Context_Menu_Paste_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴事件`)
};

const ja_context_menu_paste_title = /** @type {(inputs: Context_Menu_Paste_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントを貼り付ける`)
};

const hi_context_menu_paste_title = /** @type {(inputs: Context_Menu_Paste_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पेस्ट इवेंट्स`)
};

const pt_pt2_context_menu_paste_title = /** @type {(inputs: Context_Menu_Paste_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colar eventos`)
};

/**
* | output |
* | --- |
* | "Paste Events" |
*
* @param {Context_Menu_Paste_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_paste_title = /** @type {((inputs?: Context_Menu_Paste_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Paste_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_context_menu_paste_title(inputs)
	if (locale === "de") return de_context_menu_paste_title(inputs)
	if (locale === "it") return it_context_menu_paste_title(inputs)
	if (locale === "ru") return ru_context_menu_paste_title(inputs)
	if (locale === "es") return es_context_menu_paste_title(inputs)
	if (locale === "zh-CN") return zh_cn2_context_menu_paste_title(inputs)
	if (locale === "ja") return ja_context_menu_paste_title(inputs)
	if (locale === "hi") return hi_context_menu_paste_title(inputs)
	if (locale === "pt-PT") return pt_pt2_context_menu_paste_title(inputs)
	return en_context_menu_paste_title(inputs)
});